import Config from '@/config'
import { catalogState, loadCatalog } from './catalogStore'

export const errorMessage = (error, fallback) =>
  (error && error.body && (error.body.error || error.body.message)) || (error && error.bodyText) || fallback

const ZERO_DECIMAL_CURRENCIES = ['bif', 'clp', 'djf', 'gnf', 'jpy', 'kmf', 'krw', 'mga', 'pyg', 'rwf', 'ugx', 'vnd', 'vuv', 'xaf', 'xof', 'xpf']

const decimalPlaces = currency => (ZERO_DECIMAL_CURRENCIES.includes(String(currency).toLowerCase()) ? 0 : 2)

export const toMajorUnits = (minor, currency) => (minor / 10 ** decimalPlaces(currency)).toFixed(decimalPlaces(currency))

export const toMinorUnits = (major, currency) => {
  const text = String(major).trim()
  const match = /^(\d+)(?:\.(\d+))?$/.exec(text)
  const places = decimalPlaces(currency)
  if (!match || (match[2] || '').length > places) return null
  return Number(match[1] + (match[2] || '').padEnd(places, '0'))
}

export const detailValue = (event, fallback) =>
  event.detail && typeof event.detail.value === 'string' ? event.detail.value : fallback

const productFeaturesUrl = productId => `${Config.api.stripeMirrorProducts}/${encodeURIComponent(productId)}/features`

export const pairMethods = {
  detailValue,
  productFeaturesUrl,
  async attachPair(productId, featureId) {
    const res = await this.$http.post(productFeaturesUrl(productId), { featureId })
    const others = this.attachments.filter(a => !(a.productId === productId && a.featureId === featureId))
    this.attachments = [...others, (res.body && res.body.attachment) || { productId, featureId }]
    return res.body
  },
  async detachPair(productId, featureId) {
    const res = await this.$http.delete(`${productFeaturesUrl(productId)}/${encodeURIComponent(featureId)}`)
    this.attachments = this.attachments.filter(a => !(a.productId === productId && a.featureId === featureId))
    return res.body
  },
  unmirroredNotice(names, verb = 'changed') {
    return `${names.join(', ')} ${verb} in Stripe, but the mirror was not updated. Run "Sync".`
  },
}

export const formatPrice = price => {
  const amount = price.unitAmount == null ? 'custom' : toMajorUnits(price.unitAmount, price.currency)
  const every = price.interval ? ` / ${price.intervalCount > 1 ? `${price.intervalCount} ` : ''}${price.interval}` : ' one-off'
  return `${amount} ${String(price.currency).toUpperCase()}${every}`
}

const sharedField = name => ({
  get: () => catalogState[name],
  set: value => {
    catalogState[name] = value
  },
})

export default {
  data() {
    return {
      notice: '',
      busyKey: '',
    }
  },
  computed: {
    mode: sharedField('mode'),
    features: sharedField('features'),
    products: sharedField('products'),
    attachments: sharedField('attachments'),
    includeArchived: sharedField('includeArchived'),
    isLoading: sharedField('isLoading'),
    loaded: sharedField('loaded'),
    loadError: sharedField('loadError'),
    isLive() {
      return this.mode === 'live'
    },
    modeLabel() {
      return this.isLive ? 'LIVE' : 'TEST'
    },
    featureById() {
      return Object.fromEntries(this.features.map(f => [f.id, f]))
    },
    productById() {
      return Object.fromEntries(this.products.map(p => [p.id, p]))
    },
  },
  methods: {
    ...pairMethods,
    toggleArchived(event) {
      if (!event.detail || typeof event.detail.checked !== 'boolean') return
      this.includeArchived = event.detail.checked
      this.loadCatalog()
    },
    loadCatalog,
    attachedFeatureIds(productId) {
      return this.attachments.filter(a => a.productId === productId).map(a => a.featureId)
    },
    attachedProductIds(featureId) {
      return this.attachments.filter(a => a.featureId === featureId).map(a => a.productId)
    },
  },
}
